import { Form } from 'antd';
import { RevxRadio } from 'components';
import {
  JobconfigBindingDRingIcon,
  JobconfigBindingRoundRingIcon,
} from 'components/Icons';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxRadioProps } from 'components/RevxRadio';
import { BINDING_TYPE_ENUM } from 'domains/jobconfigDomain';
import { ConfigSvcProps } from '..';
import CommonJobSvcOption from '../common/CommonJobSvcOption';

const Binder = (props: ConfigSvcProps) => {
  const { jobOptionSvc, id } = props;

  // const optionSvc = useMemo(() => {
  //   return (
  //     jobOptionSvcs?.find((svc) => svc.name === formCache?.binder?.name) ||
  //     jobOptionSvcs?.[0]
  //   )?.options;
  // }, [formCache, jobOptionSvcs]);
  const bindingTypeRadioProps: RevxRadioProps = {
    outSideRevxLayoutProps: {
      align: 'bottom',
      justify: 'left',
      className: 'jobconfig-jobOption-content-outSideOption',
    },
    inSideRevxLayoutProps: {
      align: 'center',
      className: 'jobconfig-jobOption-content-inSideOption',
    },
    iconSequence: 'last',
    options: [
      {
        value: BINDING_TYPE_ENUM['D-Ring'],
        children: (
          <RevxFlexLayout direction="column">
            <JobconfigBindingDRingIcon style={{ width: 64, height: 60 }} />
            <label>D-Ring</label>
          </RevxFlexLayout>
        ),
      },
      {
        value: BINDING_TYPE_ENUM['Round Ring'],
        children: (
          <RevxFlexLayout direction="column">
            <JobconfigBindingRoundRingIcon style={{ width: 64, height: 60 }} />
            <label>Round Ring</label>
          </RevxFlexLayout>
        ),
      },
    ],
    // .filter((item) =>
    //   jobOptionSvc.options.map((svc) => svc.values).includes(item.value)
    // ),
  };
  return (
    <>
      <div className="jobconfig-jobOption-content-title">
        {jobOptionSvc.typeName}
      </div>
      <div
        className="jobconfig-jobOption-content-subTitle"
        style={{ marginBottom: 12 }}
      >
        {jobOptionSvc.name}
      </div>
      <RevxFlexLayout>
        <Form.Item name={[id, 'spec', 'Type']}>
          <RevxRadio {...bindingTypeRadioProps} />
        </Form.Item>
        <CommonJobSvcOption {...props} optionLabelMarginBottom={10} />
      </RevxFlexLayout>
      {/* <CommonQuantityPerBundle {...props} /> */}
      {/* <CommonJobSvcSpec
        {...props}
        customerParameterLabels={jobOptionSvc.parameterLabels.filter(
          (label) => label.toLocaleLowerCase() !== 'type'
        )}
      /> */}
      <div className="jobconfig-jobOption-content-border"></div>
    </>
  );
};

export default Binder;
